<template>
  <div class="add-coupons">
    <div class="add-btn" @click="handleAdd">
      <p>{{gettext('兑换优惠券')}}</p>
      <i class="c-common_icon_add_card"></i>
    </div>
    <!-- 兑换半浮层 -->
    <half-popup
      :title="gettext('兑换优惠券')"
      :isShow="isShow" 
      isInput
      @clickMask="clickMask"
      >
      <div slot="content">
        <rich-input 
          ref="codeInput"
          v-model="codeValue"
          @input="handleInput"
          @focus="handelFocus" 
          @blur="onTextareaBlur"
          :clearable="true"
          :autofocus="true"
          :is-error="isShowErrorMsg"
          :error="isShowErrorMsg?gettext('兑换失败，请再试一次'):''"
          :placeholder="gettext('输入兑换码')"
        />
        <!-- <div class="exchange-code-submit-error">
          <span v-if="isShowErrorMsg">{{gettext('兑换失败，请再试一次')}}</span>
        </div> -->
        <div class="submit-btn">
          <rich-button
            :disabled="btnDisabled"
            :loading="loading"
            @click="submitCode"
          >
          {{gettext('立即兑换')}}
          </rich-button>
        </div>
      </div>
    </half-popup>
  </div>
</template>

<script>
import HalfPopup from '@/components/half-popup/index'
import { debounce } from '@/common/js/utils'
import * as api from '@/api/newCouponsCenter/index'
import { util } from '@didi/soda-common'
import { voucherEntranceCk, voucherExchangeCk } from '../../track'

const { env } = util

export default {
  name: 'addCoupons',
  components: {
    HalfPopup
  },
  data () {
    return {
      isShow: false,
      codeValue: '',
      isShowErrorMsg: false,
      btnDisabled: true,
      loading: false,
      autofocus: false
    }
  },
  methods: {
    clickMask () {
      this.isShow = false
      this.codeValue = ''
      this.isShowErrorMsg = false
      this.$emit('couponsShow', false)
    },
    handelFocus () {
      // 解决获取焦点键盘遮挡问题
      this.$emit('couponsShow', true)
    },
    handleInput (val) {
      this.btnDisabled = !val
      if (!val) {
        this.isShowErrorMsg = false
      }
    },
    // 处理ios软键盘收起后页面高度无法正常展示的问题
    // onTextareaBlur () {
    //   setTimeout(() => {
    //     document.body.scrollTop = document.documentElement.scrollTop = 0
    //   }, 0)
    // },
    // 兑换弹窗
    handleAdd () {
      this.isShow = true
      this.autofocus = true
      // 兑换券点击埋点
      voucherEntranceCk()
      this.$nextTick(() => {
        this.$refs.codeInput.$refs.input.focus()
        this.$emit('couponsShow', true)
      })
    },
    // 立即兑换
    submitCode: debounce(async function () {
      if (this.btnDisabled) return
      let data = {
        code: this.codeValue,
        enterTime: new Date().getTime(),
        channelNo: env.inEmbedCustomerApp ? 1 : 2 // 1 代表嵌入端 2 代表独立端
      }
      this.loading = true
      try {
        const res = await api.exchangeCoupon(data)
        this.loading = false
        // 商家券兑换兼容低版本
        if (+res.errno === 10106) {
          this.clickMask()
          const toast = this.$createToast({
            time: 1000,
            txt: res.errmsg,
            type: 'error'
          })
          toast.show()
        } else if (res.errno) {
          this.isShowErrorMsg = true
          this.getVoucherExchangeCk(0)
        } else {
          const toast = this.$createToast({
            time: 1000,
            txt: this.gettext('兑换成功'),
            type: 'correct'
          })
          toast.show()
          this.clickMask()
          this.getVoucherExchangeCk(1)
          this.$emit('exchangeSuccess', res.data)
        }
      } catch (e) {
        this.getVoucherExchangeCk(0)
        this.$emit('exchangeFail', e)
      }
    }, 300),

    // 兑换结果埋点
    getVoucherExchangeCk (status, id, type) {
      voucherExchangeCk({
        exchange_status: status, // 0.失败 1.成功
        coupon_id: id,
        coupon_type: type// 1.平台券2.商家券
      })
    }
  }
}
</script>

<style>
  input::-webkit-input-placeholder {  
    /* WebKit browsers */  
    /* font-family: "Aspira Light"!important; */
  }
</style>
<style scoped lang="scss">
  .add-coupons{
    margin-bottom: 20px;
  }
  .add-btn{
    display: flex;
    background: #FFFFFF;
    border-radius: 12px;
    height: 128px;
    line-height: 128px;
    font-family: 'Aspira Medium';
    font-size: 32px;
    padding: 0 40px;
    p{
      flex: 1;
    }
    i{
      font-size: 32px;
      line-height: 128px;
      color: #000;
    }
  }
  // .exchange-code-submit-error{
  //   font-family: 'Aspira Light';
  //   font-size: 28px;
  //   color:#ED2D2D;
  //   margin-top: 12px;
  // }
  .submit-btn{
    position: relative;
    left: 0;
    width: calc(100vw - 80px);
    font-family: 'Aspira Regular';
    height: 88px;
    border-radius: 8px;
    font-size: 36px;
    color: #FFFFFF;
    margin-top: 88px;
  }
  // /deep/ .rich-input:after{
  //   border:none;
  //   border-bottom:2px solid #CDCDCD;
  // }
  .code-error:after{
    border-bottom:2px solid #ED2D2D;
  }
  // .rich-input{
  //   font-family: 'Aspira Light';
  //   font-size: 48px;
  //   color: #000000;
  //   caret-color: #FE7F3F;
  //   margin:88px 0 0 0;
  // }
  // /deep/ .rich-input-field{
  //   font-family: 'Aspira Medium';
  //   padding: 12px 0;
  //   color: #000;
  //   text-indent: 5px;
  // }
  // /deep/ .rich-input-clear>i{
  //   font-size: 36px;
  //   color: #cccccc;
  //   padding: 0;
  // }
  // /deep/ .rich-input-clear, .rich-input-eye{
  //   text-align: right;
  //   padding: 10px 0 10px 30px!important;
  // }
  .rich-btn{
    font-family: 'Aspira Regular';
  }
</style>